<template>
  <el-form
    ref="form"
    size="medium"
    v-loading="loading"
    :model="form"
    :rules="rules"
    :validate-on-rule-change="true"
    label-width="150px"
  >
    <el-row>
      <div class="section-title">主体信息</div>
      <el-col :span="24">
        <el-form-item label="真实姓名" prop="companyName">
          <el-input
            :disabled="isEdit"
            v-model="form.companyName"
            placeholder="请填写真实姓名"
            class="form-field"
            type="text"
            autocomplete
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="证件类型" prop="idCodeType">
          <el-select v-model="form.idCodeType" placeholder="请选择" class="form-field" :disabled="isEdit">
            <el-option
              v-for="(text,key) in IDTypeMap"
              :key="+key"
              :label="text"
              :value="+key"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="证件号码" prop="idCode">
          <el-input
            v-model="form.idCode"
            :disabled="isEdit"
            class="form-field"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item :label="$t('person.phone')" prop="phoneNum">
          <el-input v-model="form.phoneNum" :placeholder="$t('person.phonePlaceholder')" class="form-field"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('person.email')" prop="email">
          <el-input
            v-model="form.email"
            :placeholder="$t('person.emailPlaceholder')"
            class="form-field"
            type="email"
            autocomplete
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('person.address')" prop="cpAddress">
          <el-input v-model="form.cpAddress" :placeholder="$t('person.addressPlaceholder')" class="form-field"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item :label="$t('person.qq')" prop="qqNum">
          <el-input v-model="form.qqNum" :placeholder="$t('person.qqPlaceholder')" class="form-field"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="证件正面照上传" :prop="`${idFileFront.name}List`">
          <verify-uploader
            action="/action/upload"
            drag
            :accept="`.${imageType.join(',.')}`"
            :limit="1"
            :file-list="form[`${idFileFront.name}List`]"
            :disabled="photoUploading[idFileFront.name] || isEdit"
            :before-upload="(...p)=>handleLicenseBefore(idFileFront.name,...p)"
            :on-success="(...p)=>handleLicenseSuccess(idFileFront,...p)"
            :on-remove="(...p)=>handleLicenseRemove(idFileFront.name,...p)"
            :on-error="(...p)=>handleLicenseError(idFileFront.name,...p)"
            :on-preview="handleLicensePreview"
          >
            <div slot="trigger" class="upload-trigger">
              <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
              <p>点击或将文件拖拽到此处</p>
              <span>支持格式：{{ imageType.join(',') }}</span>
            </div>
            <div slot="tip" class="el-upload__tip">
              <div>请上传证件正面照，确保证件号码及其他信息清晰可见</div>
            </div>
          </verify-uploader>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="证件反面照上传" :prop="`${idFileBack.name}List`">
          <verify-uploader
            action="/action/upload"
            drag
            :accept="`.${imageType.join(',.')}`"
            :limit="1"
            :file-list="form[`${idFileBack.name}List`]"
            :disabled="photoUploading[idFileBack.name] || isEdit"
            :before-upload="(...p)=>handleLicenseBefore(idFileBack.name,...p)"
            :on-success="(...p)=>handleLicenseSuccess(idFileBack,...p)"
            :on-remove="(...p)=>handleLicenseRemove(idFileBack.name,...p)"
            :on-error="(...p)=>handleLicenseError(idFileBack.name,...p)"
            :on-preview="handleLicensePreview"
          >
            <div slot="trigger" class="upload-trigger">
              <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
              <p>点击或将文件拖拽到此处</p>
              <span>支持格式：{{ imageType.join(',') }}</span>
            </div>
            <div slot="tip" class="el-upload__tip">
              <div>请上传证件反面照，确保证件号码及其他信息清晰可见</div>
            </div>
          </verify-uploader>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="证件手持照上传" :prop="`${idFileHand.name}List`">
          <verify-uploader
            action="/action/upload"
            drag
            :accept="`.${imageType.join(',.')}`"
            :limit="1"
            :file-list="form[`${idFileHand.name}List`]"
            :disabled="photoUploading[idFileHand.name] || isEdit"
            :before-upload="(...p)=>handleLicenseBefore(idFileHand.name,...p)"
            :on-success="(...p)=>handleLicenseSuccess(idFileHand,...p)"
            :on-remove="(...p)=>handleLicenseRemove(idFileHand.name,...p)"
            :on-error="(...p)=>handleLicenseError(idFileHand.name,...p)"
            :on-preview="handleLicensePreview"
          >
            <div slot="trigger" class="upload-trigger">
              <svg-icon icon-class="upload" class="upload-icon"></svg-icon>
              <p>点击或将文件拖拽到此处</p>
              <span>支持格式：{{ imageType.join(',') }}</span>
            </div>
            <div slot="tip" class="el-upload__tip">
              <div>请上传证件手持照片，确保证件号码及其他信息清晰可见</div>
            </div>
          </verify-uploader>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { imageType } from '@/utils/constants'
import { emailValidate, validateFileExt } from '@/utils/validate'
import VerifyUploader from '@/components/VerifyUploader'
import { Private, ID_FILE_KEY_TYPE_ENUM, IDTypeMap } from '../../const'

export default {
  name: 'PersonForm',
  components: {
    VerifyUploader
  },
  props: {
    isEdit: Boolean,
    defaultData: Object,
    loading: Boolean,
  },
  data() {
    const isZH = this.$i18n.locale === 'zh'

    const setValidator = (fn, zhText, enText, trigger = 'blur') => {
      const validator = (rule, value, cb) => {
        if (fn(value)) return cb()
        cb(new Error(isZH ? zhText : enText))
      }
      return {
        validator,
        trigger
      }
    }

    const setRequired = (zhText, enText, trigger = 'blur') => {
      return {
        required: true,
        message: isZH ? zhText : enText,
        trigger
      }
    }

    return {
      imageType,
      IDTypeMap,
      idFileFront: ID_FILE_KEY_TYPE_ENUM.FRONT,
      idFileBack: ID_FILE_KEY_TYPE_ENUM.BACK,
      idFileHand: ID_FILE_KEY_TYPE_ENUM.HAND,

      form: new Private(),
      photoUploading: {
        [ID_FILE_KEY_TYPE_ENUM.FRONT.name]: false,
        [ID_FILE_KEY_TYPE_ENUM.BACK.name]: false,
        [ID_FILE_KEY_TYPE_ENUM.HAND.name]: false
      },

      rules: {
        companyName: [setRequired('请输入姓名', 'Please input name')],
        idCodeType: [setRequired('请选择证件类型', 'Please select card type')],
        idCode: [setRequired('请输入证件号码', 'Please input card code')],
        phoneNum: [setRequired('请填写联系电话', 'Please input your phone number')],
        email: [
          setRequired('请填写邮箱', 'Please input your email'),
          setValidator(emailValidate, '请填写正确邮箱', 'wrong email')
        ],
        cpAddress: [setRequired('请填写联系地址', 'Please input your address')],

        [`${ID_FILE_KEY_TYPE_ENUM.FRONT.name}List`]: [{ ...setRequired('请上传照片', 'Please upload file'), type: 'array' }],
        [`${ID_FILE_KEY_TYPE_ENUM.BACK.name}List`]: [{ ...setRequired('请上传照片', 'Please upload file'), type: 'array' }],
        [`${ID_FILE_KEY_TYPE_ENUM.HAND.name}List`]: [{ ...setRequired('请上传照片', 'Please upload file'), type: 'array' }],
      },
    }
  },
  created() {
    if (this.defaultData) {
      this.form = new Private(this.defaultData)
    }
  },
  mounted() {
    this.$refs.form.clearValidate()
  },
  methods: {
    handleLicenseBefore(type, file) {
      if (!validateFileExt(imageType, file.name)) {
        this.$message.warning('不支持的文件类型')
        return Promise.reject()
      }

      if (file.size > 5 * 1024 * 1024) {
        this.$message.warning('文件大于 5M')
        return Promise.reject()
      }

      this.photoUploading[type] = true
    },
    handleLicenseSuccess(enumV, resp, file, fileList) {
      const respData = resp.data
      const fileData = {
        url: this.$toPreview(respData.url),
        md5: respData.md5,
        name: file.name,
        fileName: file.name,
        filePath: respData.file_id,
        fileUrl: respData.url,
        fileType: enumV.code
      }

      this.form[`${enumV.name}List`].push(fileData)
      this.photoUploading[enumV.name] = false
    },
    handleLicenseError(type, err, file, fileList) {
      this.form[`${type}List`] = fileList
      this.photoUploading[type] = false
      this.$message({
        type: 'error',
        message: '图片上传失败: ' + err.message,
        error: err
      })
    },
    handleLicenseRemove(type, file, fileList) {
      this.form[`${type}List`] = fileList
      this.photoUploading[type] = false
    },
    handleLicensePreview(file) {
      open(file.url, '_blank')
    },

    async genData() {
      const valid = await this.$refs.form.validate().catch(_ => {
        this.$alert('有字段未填写完整, 请检查', '提示', { type: 'warning' })
      })

      if (!valid) throw new Error('表单校验失败')

      const postData = this.form.getBackendData()
      return postData
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.other-info {
  /deep/ .el-form-item {
    margin-bottom: 16px
  }
}

.form-field {
  width: 600px;
}
.el-icon-plus {
  cursor: pointer;
  color: $success;
}
.el-icon-delete {
  cursor: pointer;
  color: $danger;
  margin-left: 8px;
}
.el-upload__tip {
  div {
    line-height: 2;
  }
}

.cp-input {
  margin-bottom: 4px;
  width: 400px;

  &.approved {
    +.status {
      position: absolute;
      left: 335px;
      color: rgb(85, 180, 85);
      font-style: italic;
    }
  }
}

::v-deep {
   .el-upload.el-upload--text {
    width:300px;
    height:150px;
    background: #FAFBFB;
    border: 1px dashed #4071FF;
    border-radius: 4px;
    padding: 10px;
  }

  .el-upload-list{
    width: 300px;
  }

  .el-upload-dragger {
    background-color: unset;
    border: none;
    width: 100%;
    height: 100%;
  }
}

</style>
